import { fromJS } from 'immutable';
import { CHOOSE_BENCH_POSITION, RETREAT, RETREAT_DONE, RETREAT_START } from './constants';
import { APP_RESET } from '../App/constants';
import { CLOSE_CONTEXT_MENU } from '../ActiveGame/constants';

const initialState = fromJS({
  retreatFlowing: false,
  retreating: false,
  choosingEnergies: false,
  choosingBenchPosition: false,
  energyAttachmentIds: [],
  benchPosition: null,
  // Who switches in when that was chosen before the energy (by dragging); null when it's picked after.
  chosenBenchPosition: null,
});

function reducer(state = initialState, action) {
  switch (action.type) {

    case RETREAT_START:
      return state.set('retreatFlowing', true)
        .set('choosingEnergies', true)
        .set('choosingBenchPosition', false)
        .set('chosenBenchPosition', action.payload.get('benchPosition'));

    case CHOOSE_BENCH_POSITION:
      return state.set('retreatFlowing', true)
        .set('choosingEnergies', false)
        .set('energyAttachmentIds', action.payload.get('energyAttachmentIds'))
        .set('choosingBenchPosition', true);

    case RETREAT:
      return state.set('retreating', true)
        .set('benchPosition', action.payload.get('benchPosition'));

    case RETREAT_DONE:
      return initialState;

    // Closing the energy menu before choosing is backing out of the retreat, or nothing could start another.
    case CLOSE_CONTEXT_MENU:
      return state.get('choosingEnergies') ? initialState : state;

    case APP_RESET:
      return initialState;

    default:
      return state;
  }
}

export default reducer;
